import * as Yup from 'yup'


/** Reject Seller Market Product Order Item schema */
const sellerMarketProductOrderItemRejectFormSchema = Yup.object().shape({
  refund_reason         : Yup.string().required('Required'),
  reject_reason_details : Yup.string()
})

export default sellerMarketProductOrderItemRejectFormSchema
